import React, { useEffect, useState, useRef } from 'react';
// import { useNavigate } from 'react-router-dom';
import './FocusHelper.css'; // Importing CSS for styling
import Icon from '@mdi/react';
import { mdiWindowClose } from '@mdi/js';
import { mdiRestore } from '@mdi/js';
import { LocalizationProvider, DateTimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import dayjs from 'dayjs';


const FocusHelper = ({ onEventSelect }) => {
  const [events, setEvents] = useState([]);
  const [archiveEvents, setArchiveEvents] = useState([]);
  const [finishedEvents, setFinishedEvents] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [clients, setClients] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [newEvent, setNewEvent] = useState({ datetime: null, event: '', client: '' });
  const [activeTab, setActiveTab] = useState('SCHEDULED'); // State for active tab
  const [confirmDelete, setConfirmDelete] = useState({ show: false, eventId: null });
  const [confirmRestore, setConfirmRestore] = useState({ show: false, eventId: null });
  // const navigate = useNavigate(); // Initialize useNavigate
  // const datetimeInputRef = useRef(null); // Create a ref for the datetime input

  const currentTime = new Date();
  const twoHoursAgo = new Date(currentTime.getTime() - 2 * 60 * 60 * 1000);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await fetch('https://focusprojectsoft.com/api/total-clients-events');
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        setEvents(data);
      } catch (error) {
        console.error("Error fetching events:", error);
      }
    };

    const savedTab = localStorage.getItem('activeTab');
    if (savedTab) {
      setActiveTab(savedTab);
    }
  
    const fetchClients = async () => {
      try {
        const response = await fetch('https://focusprojectsoft.com/api/clients-telegram');
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        setClients(data); // Assuming the response is an array of clients
      } catch (error) {
        console.error("Error fetching clients:", error);
      }
    };
  
    const fetchArchiveEvents = async () => {
      try {
        const response = await fetch('https://focusprojectsoft.com/api/total-clients-archive-events');
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        setArchiveEvents(data);
      } catch (error) {
        console.error("Error fetching events:", error);
      }
    };

    const fetchFinishedEvents = async () => {
      try {
        const response = await fetch ('https://focusprojectsoft.com/api/total-clients-finished-events');
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        setFinishedEvents(data);
      } catch (error) {
        console.error("Error fetching finished events:", error);
      }
    }
  
    fetchEvents();
    fetchClients();
    fetchArchiveEvents();
    fetchFinishedEvents();
  
    const eventsIntervalId = setInterval(fetchEvents, 1500);
    const archiveIntervalId = setInterval(fetchArchiveEvents, 60000); // 20 seconds
    const finishedIntervalId = setInterval(fetchFinishedEvents, 30000); // 60 seconds
  
    return () => {
      clearInterval(eventsIntervalId);
      clearInterval(archiveIntervalId);
      clearInterval(finishedIntervalId);
    };
  }, []);
  

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  const getBackgroundColor = (status) => {
    switch (status) {
      case "confirmed":
        return "#2b626d"; // Dark gray for confirmed
      case "canceled":
        return "#182525"; // Red for canceled
      case "scheduled":
        return "#662a70"; // Teal for scheduled
      case "pinned":
        return "#c43339"; // Light purple for pinned
      default:
        return "#182525"; // Default dark background
    }
  };

  const filteredEvents = [
    ...events,
    ...archiveEvents,
    ...finishedEvents
  ].filter(event => 
    event.event.toLowerCase().includes(searchTerm.toLowerCase()) ||
    event.client.toLowerCase().includes(searchTerm.toLowerCase())
  );
  

  const handleAddEventToggle = () => {
    setShowForm(!showForm);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewEvent(prevState => ({ ...prevState, [name]: value }));
  };

  // const handleFocus = () => {
  //   if (datetimeInputRef.current && 'showPicker' in datetimeInputRef.current) {
  //     datetimeInputRef.current.showPicker();
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { userId, event, client } = newEvent;
    const formattedDatetime = newEvent.datetime ? newEvent.datetime.toISOString() : null;

    try {
      const response = await fetch(`https://focusprojectsoft.com/api/client-event/create`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ userId, formattedDatetime, event, client }),
      });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      setShowForm(false); // Hide the form after submission
      setNewEvent({ datetime: '', event: '', client: '' }); // Reset the form
    } catch (error) {
      console.error("Error creating event:", error);
    }
  };

  // Functions to filter events based on active tab
  const getTabEvents = () => {
    if (activeTab === 'SCHEDULED') {
      return filteredEvents
      .slice()
      .filter(event => 
        event.deleted_at == null && 
        ((event.datetime && new Date(event.datetime) >= twoHoursAgo) || 
         (!event.datetime && !event.confirm))
      )
      .sort((a, b) => {
        return (a.confirm === b.confirm) ? 0 : a.confirm ? 1 : -1;
      });
    } else if (activeTab === 'CONFIRMED') {
      return filteredEvents.filter(event => 
        event.deleted_at == null && 
        event.confirm
      );
    } else if (activeTab === 'FINISHED') {
      return filteredEvents.filter(event => 
        event.deleted_at == null && 
        (
          (event.datetime && new Date(event.datetime) < twoHoursAgo && !event.confirm) || 
          (event.datetime && !event.confirm && !(event.datetime && new Date(event.datetime) >= twoHoursAgo)) || 
          event.confirm
        )
      );
    } else if (activeTab === 'ARCHIVE') {
      return filteredEvents.filter(event => 
        event.deleted_at != null
      );
    }
  
    return [];
  };
  

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    localStorage.setItem('activeTab', tab);  // Save the tab to localStorage
  };

  const tabEventCounts = {
    SCHEDULED: filteredEvents.filter(event => 
      event.deleted_at == null && 
      (
        (event.datetime && new Date(event.datetime) >= twoHoursAgo) || 
        (!event.datetime && !event.confirm)
      )
    ).length,
  
    CONFIRMED: filteredEvents.filter(event => 
      event.deleted_at == null && 
      event.confirm
    ).length,
  
    FINISHED: filteredEvents.filter(event => 
      event.deleted_at == null && 
      (
        (event.datetime && new Date(event.datetime) < twoHoursAgo && !event.confirm) ||
        (event.datetime && !event.confirm && !(event.datetime && new Date(event.datetime) >= twoHoursAgo)) || 
        event.confirm
      )
    ).length,
  
    ARCHIVE: filteredEvents.filter(event => 
      event.deleted_at != null
    ).length,
  };
  

  const handleDeleteEvent = async (eventId) => {
    await fetch(`https://focusprojectsoft.com/api/event-delete/${eventId}`, {
      method: 'GET',
    });
    setEvents(events.filter(event => event.id !== eventId));
    setConfirmDelete({ show: false, eventId: null });
  };

  const openModal = (eventId) => {
    setConfirmDelete({ show: true, eventId });
  };


  const handleRestoreEvent = async (eventId) => {
    await fetch(`https://focusprojectsoft.com/api/event-restore/${eventId}`, {
      method: 'GET',
    });
    setArchiveEvents(archiveEvents.filter(event => event.id !== eventId));
    setConfirmRestore({ show: false, eventId: null });
  };

  const openRestoreModal = (eventId) => {
    setConfirmRestore({ show: true, eventId });
  };

  const handleDateChange = (newValue) => {
    setNewEvent(prevState => ({ ...prevState, datetime: newValue }));
  };
  const dateTimePickerRef = useRef(null);

  
  return (
    <div style={{ color: '#a9a3a6' }}>
      <button className="add-event-button" onClick={handleAddEventToggle}>
        + Add Event
      </button>
      {showForm && (
        <form onSubmit={handleSubmit} className="event-form">
          <textarea
            name="event"
            value={newEvent.event}
            onChange={handleInputChange}
            placeholder="Event description"
            required
            className="full-width-input"
          />
          <div className="input-row">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DateTimePicker
              label="Select Date and Time"
              value={newEvent.datetime}
              onChange={handleDateChange}
              renderInput={(params) => <input {...params} required className="half-input" />}
              ampm={false} // Disable AM/PM for 24-hour format
              ref={dateTimePickerRef} // Add this line
            />
            </LocalizationProvider>
            <select name="client" value={newEvent.client} onChange={handleInputChange} required className="half-input">
              <option value="">Select Client</option>
              {clients.map(client => (
                <option key={client} value={client}>{client}</option>
              ))}
            </select>
          </div>

          <button type="submit">Save Event</button>
        </form>
      )}
      <input 
        type="text" 
        placeholder="Search..." 
        value={searchTerm} 
        onChange={handleSearch} 
        className="search-bar"
      />
      
      {/* Tab Navigation */}
      <div className="tab-container">
        {['SCHEDULED', 'CONFIRMED', 'FINISHED', 'ARCHIVE'].map(tab => (
          <button 
            key={tab} 
            className={`tab-button ${activeTab === tab ? 'active' : ''}`} 
            onClick={() => handleTabChange(tab)}
          >
            {tab} {tabEventCounts[tab]}
          </button>
        ))}
      </div>
      
      <div className="notes-container">
        {getTabEvents().map((event, index) => {
          const status = event.confirm ? "confirmed" : 
                         (new Date(event.datetime) < twoHoursAgo && event.datetime != null ? "canceled" : 
                         (event.datetime != null ? "scheduled" : "pinned"));
          const backgroundColor = getBackgroundColor(status);

          return (
            <div
              className="note-card"
              key={index}
              style={{ background: backgroundColor }}
            >
              <div className="row flex-row">
                <h4 className="status-pill" onClick={() => {
                console.log("Event selected:", event);
                onEventSelect(event);
              }}>
                  {event.confirm ? "🟢 CONFIRMED EVENT" : 
                  (new Date(event.datetime) < twoHoursAgo && event.datetime != null ? "🚫 FINISHED - NO CONFIRM" : 
                  (event.datetime != null ? "📆 SCHEDULED EVENT" : "🚨 NO DATE 🚨"))}
                </h4>
                {event.deleted_at != null ? (
                  <Icon 
                    path={mdiRestore} 
                    size={1} 
                    className="restore-icon" 
                    onClick={() => openRestoreModal(event.id)} 
                  />
                ) : (
                  <Icon 
                    path={mdiWindowClose} 
                    size={1} 
                    className="cancel-icon" 
                    onClick={() => openModal(event.id)} 
                  />
                )}
              </div>
              
              <h3 onClick={() => {
                console.log("Event selected:", event);
                onEventSelect(event);
              }}>{event.event}</h3>
              <p onClick={() => {
                console.log("Event selected:", event);
                onEventSelect(event);
              }}><strong>Time:</strong> {event.timeISo}</p>
              <p onClick={() => {
                console.log("Event selected:", event);
                onEventSelect(event);
              }}><strong>Client:</strong> {event.client}</p>
            </div>
          );
        })}
      </div>

      {confirmDelete.show && (
        <div className="modal-overlay">
          <div className="modal">
            <h4>Are you sure you want to delete this event?</h4>
            <div className="modal-actions">
              <button className="confirm-button" onClick={() => handleDeleteEvent(confirmDelete.eventId)}>Yes</button>
              <button className="cancel-button" onClick={() => setConfirmDelete({ show: false, eventId: null })}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {confirmRestore.show && (
        <div className="modal-overlay">
          <div className="modal">
            <h4>Are you sure you want to restore this event?</h4>
            <div className="modal-actions">
              <button className="confirm-button" onClick={() => handleRestoreEvent(confirmRestore.eventId)}>Yes</button>
              <button className="cancel-button" onClick={() => setConfirmRestore({ show: false, eventId: null })}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>



  );
};

export default FocusHelper;
